import isObjectLike_default from "./isObjectLike.js";
import _getTag_default from "./_getTag.js";

//#region ../../node_modules/lodash-es/_baseIsMap.js
/** `Object#toString` result references. */
var mapTag = "[object Map]";
/**
* The base implementation of `_.isMap` without Node.js optimizations.
*
* @private
* @param {*} value The value to check.
* @returns {boolean} Returns `true` if `value` is a map, else `false`.
*/
function baseIsMap(value) {
	return isObjectLike_default(value) && _getTag_default(value) == mapTag;
}
var _baseIsMap_default = baseIsMap;

//#endregion
export { _baseIsMap_default as default };
//# sourceMappingURL=_baseIsMap.js.map